var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[(_vm.$route.params.id == 'expansion')?_c('ExpansionExclusiveArea'):_vm._e(),_vm._v(" "),(_vm.$route.params.id == 'lining')?_c('LiningExclusiveArea'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }